import { Routes, Route } from 'react-router-dom';
import { Routes as r } from './navigation/Routes';
import { setup } from './adapters/interceptors/retryInterceptor';
import Dashboard from './pages/dashboard';
import ForgottenPassword from './pages/forgotten-password';
import ActivationCode from './pages/activation-code';
import Home from './pages/home';
import Login from './pages/login';
import ResetPassword from './pages/reset-password';
import UserManagement from './pages/user-management';
import AuditLog from './pages/audit-log';
import Profile from './pages/profile';
import RequireAuth from './navigation/RequireAuth';
import Organisations from './pages/organsiations';
import Consultants from './pages/consultant/list/Consultants';
import Migration from './pages/migration/list';
import MigrationDetails from './pages/migration/details';
import ScanReview from './pages/scan-review';
import ConsultantAssign from './pages/consultant-assign';
import ConsultantReview from './pages/consultant-review';
import ScanCheck from './pages/scan-check';
import Procedures from './pages/procedure/list/Procedures';
import Inventories from './pages/inventory/list/Inventories';
import Preferences from './pages/preferences';
import ChangeRequests from './pages/change-requests';

function App() {
  setup();
  return (
    <main>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path={r.Login} element={<Login />} />
        <Route path={r.ForgottenPassword} element={<ForgottenPassword />} />
        <Route path={r.ResetPassword} element={<ResetPassword />} />
        <Route path={r.ActivationCode} element={<ActivationCode />} />
        <Route element={<RequireAuth />}>
          <Route path={r.Home} element={<Home />} />
          <Route path={r.Profile} element={<Profile />} />
          <Route path={r.Dashboard} element={<Dashboard />} />
          <Route path={r.Organisations} element={<Organisations />} />
          <Route path={r.Consultants} element={<Consultants />} />
          <Route path={r.Procedures} element={<Procedures />} />
          <Route path={r.Inventories} element={<Inventories />} />
          <Route path={r.ScanCheck} element={<ScanCheck />} />
          <Route path={r.ScanReview} element={<ScanReview />} />
          <Route path={r.ConsultantAssign} element={<ConsultantAssign />} />
          <Route path={r.Migration} element={<Migration />} />
          <Route path={r.MigrationDetail} element={<MigrationDetails />} />
          <Route path={r.Preferences} element={<Preferences />} />
          <Route path={r.ChangeRequests} element={<ChangeRequests />} />
          <Route path={r.ConsultantReview} element={<ConsultantReview />} />
          <Route path={r.UserManagement} element={<UserManagement />} />
          <Route path={r.AuditLog} element={<AuditLog />} />
        </Route>
        <Route path="*" element={<Login />} />
      </Routes>
    </main>
  );
}

export default App;
